import BaseTooltip from 'components/BaseTooltip'
import React from 'react'
import { CopyDashboardURL } from 'scenes/Dashboard/components/Utils/CopyDashboardURL.component'
import { ExtendableStyles } from 'utils-next/types'

import { User } from '../../../../../../../entities-next/user'

type CreateInviteButtonProps = ExtendableStyles & {
  user: User
}

export function CreateInviteButton({ className, user }: CreateInviteButtonProps) {
  return (
    <BaseTooltip title="Generate invite link" bottom wrapped>
      <CopyDashboardURL className={className} userId={user.id} />
    </BaseTooltip>
  )
}
